export const TEMPLATE_GCSEPOD = 40;
export const TEMPLATE_SCOTLAND = 41;
export const TEMPLATE_FE = 42;
export const TEMPLATE_RESITS = 43;
export const TEMPLATE_EOD = 45;
